import { render, staticRenderFns } from "./BusinessUnitItem.vue?vue&type=template&id=71074f82&scoped=true&"
import script from "./BusinessUnitItem.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitItem.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnitItem.vue?vue&type=style&index=0&id=71074f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71074f82",
  null
  
)

export default component.exports